import React from 'react';
import { ShieldCheckIcon, ArrowRightIcon, AwardIcon } from 'lucide-react';
export function EducationSafety() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#1e3d2f'
  }} aria-label="Education and Safety" data-id="element-82">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-83">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center" data-id="element-84">
          {/* Content */}
          <div className="flex-1" data-id="element-85">
            <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-86">
              Safety First
            </p>
            <h2 className="text-3xl md:text-4xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-87">
              Education &amp; Safety
            </h2>
            <div className="section-divider" data-id="element-88" />
            <p className="text-base leading-relaxed mb-6" style={{
            color: '#c8d8cc',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-89">
              FLSC offers comprehensive firearms training to both members and
              non-members throughout the year. All classes are led by NRA
              Certified Instructors and overseen by NRA Certified Range Safety
              Officers. Members receive discounted pricing on all classes.
            </p>

            <div className="space-y-3 mb-8" data-id="element-90">
              {['First Steps Rifle, Shotgun &amp; Pistol', 'New Gun Owner Orientation Classes', 'Concealed Pistol License (CPL) Training', 'NRA Certified Instructor Pathways', 'Personal Protection In &amp; Outside The Home', 'Civilian Response to Active Shooter Events (CRASE)'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-91">
                  <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'rgba(200,168,75,0.2)',
                border: '1px solid rgba(200,168,75,0.4)'
              }} data-id="element-92">
                    <div className="w-1.5 h-1.5 rounded-full" style={{
                  backgroundColor: '#c8a84b'
                }} data-id="element-93" />
                  </div>
                  <p className="text-sm" style={{
                color: '#c8d8cc',
                fontFamily: 'Inter, sans-serif'
              }} dangerouslySetInnerHTML={{
                __html: item
              }} data-id="element-94" />
                </div>)}
            </div>

            <div className="flex flex-wrap gap-3" data-id="element-95">
              <a href="/10.html" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
              backgroundColor: '#c8a84b',
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-96">
                View Class Schedule
                <ArrowRightIcon size={15} data-id="element-97" />
              </a>
              <a href="/67.html" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-medium text-sm border transition-all hover:bg-white/10" style={{
              borderColor: 'rgba(255,255,255,0.25)',
              color: '#e8e4d8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-98">
                All Classes
              </a>
            </div>
          </div>

          {/* Stats / highlights */}
          <div className="w-full lg:w-80 flex-shrink-0 grid grid-cols-2 gap-4" data-id="element-99">
            <div className="col-span-2 rounded-2xl p-6 text-center" style={{
            backgroundColor: 'rgba(200,168,75,0.12)',
            border: '1px solid rgba(200,168,75,0.25)'
          }} data-id="element-100">
              <AwardIcon size={32} className="mx-auto mb-3" style={{
              color: '#c8a84b'
            }} data-id="element-101" />
              <p className="text-2xl font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-102">
                NRA Certified
              </p>
              <p className="text-sm" style={{
              color: '#a0b8a8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-103">
                All instructors are NRA Certified. Range Safety Officers
                on-site.
              </p>
            </div>

            <div className="rounded-2xl p-5 text-center" style={{
            backgroundColor: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)'
          }} data-id="element-104">
              <ShieldCheckIcon size={24} className="mx-auto mb-2" style={{
              color: '#c8a84b'
            }} data-id="element-105" />
              <p className="text-sm font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-106">
                Members &amp; Public
              </p>
              <p className="text-xs mt-1" style={{
              color: '#7a9a8a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-107">
                Open to all
              </p>
            </div>

            <div className="rounded-2xl p-5 text-center" style={{
            backgroundColor: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)'
          }} data-id="element-108">
              <ShieldCheckIcon size={24} className="mx-auto mb-2" style={{
              color: '#c8a84b'
            }} data-id="element-109" />
              <p className="text-sm font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-110">
                Member Discount
              </p>
              <p className="text-xs mt-1" style={{
              color: '#7a9a8a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-111">
                On all classes
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}